import React, { useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Divider,
  Box,
} from "@mui/material";
import { Spin } from "antd"; // For loader/spinner
import { momentDate, upperCase } from "../../utils";

const SchoolDashboard = (props) => {
  const [loader, setLoader] = useState(false);
  const [today, setToday] = useState(momentDate(new Date(), "YYYY-MM-DD"));

  const schoolInfo = {
    name: props.dataSource.school_name,
    address: props.dataSource.school_address,
    mobile: props.dataSource.school_mobile,
    email: props.dataSource.school_email,
    contactPerson1: props.dataSource.contact_person_1 || "Not Provided",
    contactPerson2: props.dataSource.contact_person_2 || "Not Provided",
    dateOfStart: props.dataSource.created_on,
    refBy: props.dataSource.agent_name,
    totalStudents: props.schoolStats.students_count,
    totalStaff: props.schoolStats.staffs_count,
    paymentPlan: upperCase(props.dataSource.subscription_interval),
    lastPayment: props.dataSource.plan_start_on,
    nextPayment: props.dataSource.plan_expires_on,
  };

  const cardData = [
    {
      title: "Total Students",
      value: schoolInfo.totalStudents,
      color: "#42a5f5",
    },
    { title: "Total Staff", value: schoolInfo.totalStaff, color: "#ff7043" },
    { title: "Payment Plan", value: schoolInfo.paymentPlan, color: "#66bb6a" },
    { title: "Next Payment", value: schoolInfo.nextPayment, color: "#fbc02d" },
  ];

  return (
    <div style={{ padding: "20px", background: "#f4f6f9", minHeight: "100vh" }}>
      {/*   <Typography
        variant="h4"
        sx={{
          textAlign: "center",
          mb: 3,
          color: "#1976d2",
          fontWeight: "bold",
        }}
      >
        School Dashboard
      </Typography> */}
      <Grid container spacing={3}>
        {/* Stats Overview */}
        {cardData.map((data, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                background: `linear-gradient(135deg, ${data.color}, ${data.color}CC)`,
                color: "white",
                boxShadow: 3,
                height: "150px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "12px",
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {data.title}
                </Typography>
                <Typography variant="h4">{data.value}</Typography>
                {data.title.includes("Total") && (
                  <Typography variant="body2">As on {today}</Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}

        {/* School Details Section */}
        <Grid item xs={12}>
          <Card sx={{ boxShadow: 3, borderRadius: "12px", overflow: "hidden" }}>
            <Box
              sx={{
                background: "linear-gradient(135deg, #1976d2, #478ed1)",
                color: "white",
                padding: "20px",
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                {schoolInfo.name}
              </Typography>
              <Typography variant="body1">{schoolInfo.address}</Typography>
            </Box>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                    <strong>Mobile:</strong> {schoolInfo.mobile}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Email:</strong> {schoolInfo.email}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Contact Person 1:</strong>{" "}
                    {schoolInfo.contactPerson1}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Contact Person 2:</strong>{" "}
                    {schoolInfo.contactPerson2}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                    <strong>Date of Start:</strong> {schoolInfo.dateOfStart}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Referred by:</strong> {schoolInfo.refBy}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Loader */}
      {loader && (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <Spin size="large" />
        </Box>
      )}
    </div>
  );
};

export default SchoolDashboard;
